module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "badge",
    class: {
      'badge_right': _vm.isRightBadge
    }
  }, [_c('p', {
    staticClass: "badge__count"
  }, [_vm._t("default")], 2), _c('p', {
    staticClass: "badge__text"
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08b76352","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/competences/card/components/badge/Badge.vue
// module id = b0727c561a6936471abd
// module chunks = 0